var map = {
	"./Facebook Logo.png": "f63a",
	"./Google Logo.png": "59b2",
	"./alur-gel-4.png": "11f9",
	"./alur-ppdb.png": "4b79",
	"./animasi.png": "80d8",
	"./character.png": "dc5b",
	"./contoh image preview.png": "1ba8",
	"./desain-grafika.png": "9076",
	"./desain-komunikasi-visual.png": "6845",
	"./logo.png": "4ffd",
	"./major-thumbnail/animasi-major.png": "e71b",
	"./major-thumbnail/desain-grafika-major.png": "c057",
	"./major-thumbnail/dkv-major.png": "0297",
	"./major-thumbnail/produksi-grafika-major.png": "6f1f",
	"./major-thumbnail/rpl-major.png": "fc3f",
	"./produksi-grafika.png": "b0f5",
	"./rekayasa-perangkat-lunak.png": "9be6",
	"./rincian-1.png": "d9c0",
	"./rincian-2.png": "6e42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";